import {toPng} from 'html-to-image'
import {jsPDF} from 'jspdf'
import './flyer-print.css'

const triggerDownload = (dataUrl: string, filename: string) => {
  const a = document.createElement('a')
  a.href = dataUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
}

/** Capture a DOM node to a 2× PNG data URL. */
const capture = (node: HTMLElement) =>
  toPng(node, {pixelRatio: 2, cacheBust: true, backgroundColor: '#ffffff'})

export async function exportFlyerPng(node: HTMLElement, filename = 'crew-crashpad-flyer.png') {
  triggerDownload(await capture(node), filename)
}

export async function exportFlyerPdf(node: HTMLElement, filename = 'crew-crashpad-flyer.pdf') {
  const dataUrl = await capture(node)
  const w = node.offsetWidth
  const h = node.offsetHeight
  const pdf = new jsPDF({orientation: h > w ? 'portrait' : 'landscape', unit: 'px', format: [w, h]})
  pdf.addImage(dataUrl, 'PNG', 0, 0, w, h)
  pdf.save(filename)
}

/** Print only the flyer poster (id `flyer-poster`) via the print stylesheet. */
export function printFlyer() {
  document.body.classList.add('ccp-flyer-printing')
  const cleanup = () => {
    document.body.classList.remove('ccp-flyer-printing')
    window.removeEventListener('afterprint', cleanup)
  }
  window.addEventListener('afterprint', cleanup)
  window.print()
  setTimeout(cleanup, 2000)
}
